
export const ALL_UNIT_REQUEST = "ALL_UNIT_REQUEST";
export const ALL_UNIT_SUCCESS = "ALL_UNIT_SUCCESS";
export const ALL_UNIT_FAIL = "ALL_UNIT_FAIL";